<div class="page-top-bar">
  <a [href]="mainWebsiteUrl">
    <img src="/assets/img/logo-dot.png" class="header-logo" alt="VoucherCart" />
  </a>
  @if (envName !== 'production') {
    <p class="envInfo">{{ envName }}</p>
  }
</div>
